import { InterviewMessage } from '@empathy/ai-chat';

import { InterviewQuote } from './ai-interview/ai-interview-statistics.model';
import { AiSnippet } from './ai-snippet.model';

export class AiTranscript {
  id: string;
  status: string;
  messages: InterviewMessage[];
  createdAt: string;
  updatedAt: string;
  digest: AiTranscriptDigest;
}

export class PendingAiTranscriptResult {
  numberPendingTranscripts: number;
}

export class AiTranscriptObject {
  title: string;
  body: string;
}

export class AiTranscriptDigest {
  summary: string;
  themes: AiTranscriptObject[];
  opportunities: AiTranscriptObject[];
  findings?: AiTranscriptObject[];
  questionSummaries?: AiTranscriptObject[];
  quotes?: InterviewQuote[];
  snippets?: AiSnippet[];
  createdAt?: Date;
}
